import React from "react";
import { Field, FieldArray } from "redux-form";
import {
    renderNumberPercentage,
} from "../../../../../../Utils/renderField/renderField";
import "./ModalForm.css";
const TableRow = ({ system, index, fields, yearList }) => {
    return (
        <tr key={`fila-${index}`}>
            {yearList.map((year, index) => {
                if (index === 0) {
                    return null;
                }
                return (
                    <td key={year} className="text-center">
                        <Field
                            name={`${system}.${year}`}
                            type="text"
                            component={renderNumberPercentage}
                            className="form-control"
                            placeholder="0.00 %"
                        />
                    </td>
                );
            })}
        </tr>
    );
};

const SimpleDollarTable = ({ fields, data }) => {
    if (!data || data.year_list.length === 0) {
        return null;
    }
    return (
        <div className="tabla-wrapper">
            <div className="scroll-container">
                <table className="custom-table">
                    <thead>
                        <tr>
                            {data.year_list.map((year, index) => {
                                if (index === 0) {
                                    return null;
                                }
                                return <th key={year}>{year}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((system, index) => (
                            <TableRow
                                key={index}
                                system={system}
                                index={index}
                                fields={fields}
                                yearList={data.year_list}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
const ModalForm = (props) => {
    return (
        <div className="modal-form-wrapper">
            <div className="modal-form-inner">
                <FieldArray
                    name="porcentaje_de_crecimiento"
                    component={SimpleDollarTable}
                    props={props}
                />
            </div>
        </div>
    );
};

export default ModalForm;
